import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class PermissionsService {
    static async permissionsAssign(queryParams) {
        return await NetworkService.postAsync(`${API_BASE_URL}/permissions/assign`, {}, queryParams);
    }

    static async permissionsUnAssign(queryParams) {
        return await NetworkService.postAsync(`${API_BASE_URL}/permissions/unassign`, {}, queryParams);
    }
}
